<!-- 嵌入式-产品库存管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onBatchClick">
        <i class="fas fa-plus"></i> 批量出库
      </el-button>
      <el-button type="primary" @click="onStatisticsClick()">
        <i class="fa fa-print"></i> 统计数据
      </el-button>
      <div class="former">
        <!-- <select2
          labelName="NameNumber"
          v-model="former.DciProductModelID"
          url="dci/model/product/list?order=name"
          clearable
          placeholder="选择产品型号"
          no-data-text="没有产品型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2> -->
        <el-select
          v-model="former.DciProductModelID"
          clearable
          placeholder="选择产品型号"
          style="width: 160px"
        >
          <el-option
            v-for="ele in modelList"
            :key="ele.ID"
            :label="ele.NameNumber"
            :value="ele.ID"
          >
          </el-option>
        </el-select>
        &nbsp;
        <el-input
          v-model.trim="former['SN|Remark:like']"
          placeholder="输入SN"
          @keydown.enter.native="onSubmitQuery"
          style="width: 140px"
        >
        </el-input
        >&nbsp;
        <el-select
          v-model="former.ClientName"
          placeholder="输入客户"
          filterable
          clearable
          style="width: 120px"
        >
          <el-option
            v-for="client in clientList"
            :key="client"
            :label="client"
            :value="client"
          ></el-option> </el-select
        >&nbsp;
        <el-select
          v-model="former.ContractNos"
          collapse-tags
          placeholder="选择合同编号"
          filterable
          clearable
          style="width: 180px"
        >
          <el-option
            v-for="(contractNo, index) in contractNoList"
            :key="index"
            :label="contractNo"
            :value="contractNo"
          ></el-option> </el-select
        >&nbsp;
        <el-select
          v-model="former.Tags"
          multiple
          collapse-tags
          placeholder="标签"
          filterable
          clearable
          style="width: 105px"
        >
          <el-option
            v-for="(tag, index) in tagList"
            :key="index"
            :label="tag"
            :value="tag"
          ></el-option> </el-select
        >&nbsp;
        <el-date-picker
          key="month"
          type="month"
          v-model="former.queryMonth"
          value-format="yyyy-MM"
          :clearable="true"
          :editable="false"
          align="center"
          placeholder="出库年月"
          @change="getChartData"
          style="width: 115px"
        ></el-date-picker
        >&nbsp;
        <el-select
          v-model="former.heartbeat"
          clearable
          placeholder="在线状态"
          style="width: 100px"
        >
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="0"></el-option>
        </el-select>
        &nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.Status"
          url="dci/product/stock-status-list"
          clearable
          placeholder="产品状态"
          no-data-text="没有状态"
          style="width: 100px"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column
        prop="DciProductModel.NameNumber"
        label="产品型号名称"
        width="190"
      />
      <el-table-column prop="SN" label="产品SN" width="170">
        <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
          <el-tag type="success" v-if="row.Remark">
            {{ row.Remark }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="DciPvProductVersion.PvName"
        label="文件系统版本"
        width="170"
      />
      <el-table-column label="标签" width="80">
        <template slot-scope="{ row }">
          <el-tag
            v-for="tag in row.Tags"
            :key="tag"
            style="margin-right: 5px; color: #00b3ca"
            >{{ tag }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="合同编号" width="170">
        <template slot-scope="{ row }">
          <el-tag
            v-for="contractNo in row.ContractNos"
            :key="contractNo"
            style="margin-right: 5px; color: #00b3ca"
            >{{ contractNo }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="ClientName" label="客户" />
      <el-table-column label="出库日期" align="center" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.StockoutAt">
            {{ scope.row.StockoutAt.substring(0, 10) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="50" align="center" label="在线状态">
        <template slot-scope="scope">
          <el-tooltip content="Top center" placement="top" effect="light">
            <div slot="content" v-if="scope.row.HeartBeat === true">
              <div v-if="scope.row.HeartBeatAt">
                在线:{{ scope.row.HeartBeatAt }}
              </div>
              <div v-else>在线</div>
            </div>
            <div slot="content" v-else>
              <div v-if="scope.row.HeartBeatAt">
                离线:{{ scope.row.HeartBeatAt }}
              </div>
              <div v-else>离线</div>
            </div>
            <i
              class="fa fa-wifi fa-lg"
              style="color: #92c655; cursor: pointer"
              v-if="scope.row.HeartBeat === true"
            ></i>
            <i
              class="fa fa-wifi fa-lg"
              style="color: #f0615e; cursor: pointer"
              v-else
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="IsQuality"
        label="是否在保"
        align="center"
        width="50"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.IsQuality === '是'" type="success"> 在保 </el-tag>
          <el-tag
            v-else-if="
              row.IsQuality === '否' &&
              row.QualityEndAt !== null &&
              row.QualityEndAt !== undefined
            "
            type="warning"
          >
            过保
          </el-tag>
          <el-tag v-else type="info"> 未知 </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="StatusName" label="状态" align="center" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.Status === 1" type="warning">
            {{ row.StatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="140" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.Status === 1"
            type="primary"
            @click.stop="onOutItem(scope.row)"
            title="出库"
          >
            <i class="fas fa-sign-in-alt"></i>
          </el-button>
          <el-button
            v-else
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onChangeAcc(scope.row)"
            title="更换配件"
          >
            <i class="fas fa-cogs"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteClick(scope.row)"
            title="删除"
            v-permission="'dci_product_stock_delete-POST'"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="删除"
      :visible.sync="deleteVisible"
      :close-on-click-modal="false"
      @close="onCloseDel"
      width="40%"
    >
      <el-form
        ref="deleteItemForm"
        label-width="100px"
        :model="deleteItem"
        :rules="deleteRules"
      >
        <el-form-item label="删除类型">
          <el-radio-group v-model="deleteItem.Type">
            <el-radio :label="0">删除该产品及关联配件</el-radio>
            <el-radio :label="1">仅删除该产品,保留配件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="Status" v-if="deleteItem.Type !== 0">
          <select2
            labelName="Value"
            valueKey="Key"
            style="width: 100%"
            :clearable="false"
            v-model="deleteItem.Status"
            url="dci/accessory/stock-status-list"
            placeholder="请选择状态"
          ></select2>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseDel">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onDeleteItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
    <out v-model="item" :visible.sync="outVisible" @form:saved="flush" />
    <edit
      v-model="item"
      :visible.sync="editVisible"
      :tag-list="tagList"
      @form:saved="flush"
    />
    <change-acc v-model="item" :visible.sync="accVisible" @form:saved="flush" />
    <batch v-model="item" :visible.sync="batchVisible" @form:saved="flush" />

    <el-dialog
      title="统计"
      :visible.sync="statisticsVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onClose()"
      width="20%"
    >
      <el-form
        ref="statisticsItemForm"
        label-width="120px"
        :model="statisticsItem"
        :rules="statisticsRules"
      >
        <el-form-item label="统计年份" prop="Year">
          <el-select
            v-model="statisticsItem.Year"
            filterable
            default-first-option
            :clearable="false"
            placeholder="请选择年份"
            style="width: 100%"
          >
            <el-option
              v-for="year in yearList"
              :key="year"
              :label="year"
              :value="year"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onClose()">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onStatistics" :disabled="submitting">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import Out from "./out.vue";
import Edit from "./edit.vue";
import ChangeAcc from "./changeAcc.vue";
import Batch from "./batch.vue";

export default {
  components: {
    Out,
    Edit,
    ChangeAcc,
    Batch,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        DciProductModelID: "",
        Status: "",
        ClientName: "",
        "SN|Remark:like": "",
        Tags: [],
        ContractNos: [],
        heartbeat: "",
        queryMonth: "",
      },
      item: this.getEmptyItem(),
      deleteItem: {
        ID: -1,
        Type: 0,
        Status: null,
      },
      deleteRules: {
        Type: [
          { required: true, message: "删除类型不能为空", trigger: "blur" },
        ],
        Status: [{ required: true, message: "状态不能为空", trigger: "blur" }],
      },
      createVisible: false,
      outVisible: false,
      editVisible: false,
      accVisible: false,
      deleteVisible: false,
      batchItem: this.getEmptyBatchItem(),
      batchVisible: false,
      tagList: [],
      contractNoList: [],
      clientList: [],
      modelList: [],
      statisticsVisible: false,
      submitting: false,
      yearList: [],
      statisticsItem: {
        Year: "",
      },
      statisticsRules: {
        Year: [
          { required: true, message: "统计年份不能为空", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getModelList();
    this.getTagList();
    this.getContractNoList();
    this.getClientList();
    this.getItemList();
    this.getYear();
  },
  methods: {
    flush() {
      this.getModelList();
      this.getTagList();
      this.getContractNoList();
      this.getClientList();
      this.getItemList();
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/product/stock-list", {
          params: {
            where: {
              DciProductModelID: this.former.DciProductModelID,
              Status: this.former.Status,
              ClientName: this.former.ClientName,
              "SN|Remark:like": this.former["SN|Remark:like"],
            },
            Tags: this.former.Tags,
            ContractNos: this.former.ContractNos,
            heartbeat: this.former.heartbeat,
            queryMonth: this.former.queryMonth,
            ...this.pager,
            with: [
              "DciProductModel",
              "DciAccessories.DciAccessoryModel",
              "DciPvProductVersion",
            ],
            order: ["-stockin_at", "-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getClientList() {
      this.$axios
        .get("dci/product/stock-clients")
        .then((response) => {
          this.clientList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getTagList() {
      this.$axios
        .get("dci/product/stock-tags")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getContractNoList() {
      this.$axios
        .get("dci/product/stock-contractNos")
        .then((response) => {
          this.contractNoList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },

    //获取产品型号列表
    getModelList() {
      this.$axios.get("dci/model/product/list?order=name").then(
        (response) => {
          this.modelList = response.data.data;
          // this.modelList.push({
          //   ID: 0,
          //   NameNumber: "其它类型",
          // });
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    onCloseDel() {
      this.deleteVisible = false;
      this.$refs.deleteItemForm.resetFields();
    },
    onDeleteClick(row) {
      this.deleteVisible = true;
      this.deleteItem.ID = row.ID;
      this.deleteItem.Type = 0;
      this.deleteItem.Status = null;
    },
    onDeleteItem() {
      this.$refs.deleteItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "dci/product/stock-delete",
            method: "post",
            data: this.deleteItem,
          })
          .then(() => {
            this.getItemList();
            this.$message.success("删除成功");
            this.deleteVisible = false;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.createVisible = true;
    },
    onOutItem(row) {
      this.item = row;
      this.outVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.editVisible = true;
    },
    onChangeAcc(row) {
      this.item = row;
      this.accVisible = true;
    },
    getEmptyItem() {
      return {};
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    //点击批量出库按钮
    onBatchClick() {
      this.batchItem = this.getEmptyBatchItem();
      this.batchVisible = true;
    },
    getEmptyBatchItem() {
      return {};
    },
    //点击统计数据按钮
    onStatisticsClick() {
      var day = new Date();
      this.statisticsItem.Year = day.getFullYear();
      this.statisticsVisible = true;
    },
    //统计数据
    onStatistics() {
      this.$refs.statisticsItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.statisticsItem);
        const itemData = { ...this.statisticsItem };
        this.$axios
          .post(`dci/product/print/statistics`, itemData, {
            responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
          })
          .then((res) => {
            if (!res) {
              return;
            }
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            }); // 构造一个blob对象来处理数据，并设置文件类型

            let fName = "统计数据表(" + this.statisticsItem.Year + ").xlsx";

            if (window.navigator.msSaveOrOpenBlob) {
              //兼容IE10
              navigator.msSaveBlob(blob, fName);
            } else {
              const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
              const a = document.createElement("a"); //创建a标签
              a.style.display = "none";
              a.href = href; // 指定下载链接
              a.download = fName; //指定下载文件名
              a.click(); //触发下载
              URL.revokeObjectURL(a.href); //释放URL对象

              this.submitting = false;
              this.onClose();
            }
            // 这里也可以不创建a链接，直接window.open(href)也能下载
          })
          .catch((err) => {
            this.submitting = false;
            this.onClose();
            console.log(err);
          });
      });
    },
    getYear() {
      this.yearList = [];
      var day = new Date();
      var year = day.getFullYear();

      for (let index = 0; index < 8; index++) {
        this.yearList.push(year);
        year -= 1;
      }
    },
    onClose() {
      this.$refs.statisticsItemForm.resetFields();
      this.statisticsVisible = false;
    },
  },
};
</script>
